var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgChoiceGrave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_21068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_21068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0748 15.7848C51.9829 12.9271 47.2588 14.3585 47.2588 14.3585L47.2183 14.3888C45.5485 14.8243 44.067 15.7942 43 17.1505L43.7081 32.8302H54.6333L55.0784 16.8824L56.0748 15.7848Z",
    fill: "#787B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1915 32.8503L45.4834 17.1707C45.4834 17.1707 50.0356 10.8735 57.3241 16.6649C57.4033 16.7357 57.4776 16.8117 57.5466 16.8925L56.5704 32.8503H46.1915Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 33C37.4556 30.4892 40.2979 29.2984 42.388 30.0516C43.415 30.4247 44.1238 30.769 45.2231 30.5897C46.8287 30.2668 48.0437 29.0258 49.5624 28.4376C50.3089 28.1064 51.1251 27.9596 51.9413 28.0095C52.7574 28.0595 53.5492 28.3048 54.249 28.7245C55.5508 29.4419 56.6862 30.7331 58.111 30.9842C60.0854 31.3357 61.9441 30.5251 63.0289 33H37Z",
    fill: "#4B4A50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 40,
    width: 19,
    height: 16,
    rx: 1,
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 63,
    width: 19,
    height: 16,
    rx: 1,
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 40,
    width: 19,
    height: 16,
    rx: 1,
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 63,
    width: 19,
    height: 16,
    rx: 1,
    fill: "#FF7D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9545 83C66.9102 83 66.8663 82.9925 66.8244 82.9775C66.7375 82.9467 66.6685 82.8859 66.6321 82.8087L65.3226 80.0383L63.7663 81.2667C63.7009 81.3266 63.5838 81.3696 63.4625 81.3696C63.2076 81.3696 63 81.1837 63 80.955V73.4146C63 73.1859 63.2076 73 63.4625 73C63.5703 73 63.6748 73.0337 63.7635 73.0979L69.8679 78.6246C69.9632 78.7291 70 78.8212 70 78.9171C70 79.1454 69.7924 79.3316 69.5375 79.3316H67.4641L68.726 82.0038C68.8006 82.1617 68.719 82.3433 68.5431 82.4117L67.094 82.9741C67.0497 82.9912 67.0021 83 66.9545 83ZM63.3127 80.7917C63.3028 80.7983 63.294 80.8054 63.2856 80.8129L63.3127 80.7917Z",
    fill: "#4B4A50"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgChoiceGrave);
export default __webpack_public_path__ + "static/media/imgChoiceGrave.e327ce62bf0438bf94073a6126ad0c9e.svg";
export { ForwardRef as ReactComponent };